import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const ThumbUpSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default ThumbUpSVG;
